import React from "react";
import CompetitorRow, { getTotalCompetitorMentions } from "./CompetitorRow";

export default function CompetitorsModal({ competitors, onClose }) {
	if (!competitors?.length) return null;

	const totalCompetitorMentions = getTotalCompetitorMentions(competitors);

	return (
		<div className="grader-dialog" onClick={onClose} role="presentation">
			<div
				className="grader-dialog__content market-competition__modal-content"
				onClick={(e) => e.stopPropagation()}
				role="dialog"
				aria-modal="true"
				aria-labelledby="competitors-modal-title"
			>
				<div className="grader-dialog__header">
					<h3 id="competitors-modal-title" className="grader-dialog__title">
						All competitors AI named ({competitors.length})
					</h3>
					<button
						type="button"
						className="grader-dialog__close"
						onClick={onClose}
						aria-label="Close"
					>
						×
					</button>
				</div>

				<p className="market-competition__modal-subtitle">
					Every competitor brand AI mentioned across the tested prompts, by mention count.
				</p>

				<ul className="market-competition__competitor-list market-competition__modal-list">
					{competitors.map((comp, i) => (
						<CompetitorRow
							key={comp.name || i}
							competitor={comp}
							totalMentions={totalCompetitorMentions}
						/>
					))}
				</ul>
			</div>
		</div>
	);
}
